export interface FileInfo {
  type?: string;
  name: string;
  /** the unique key that this file will be uploaded as */
  key?: string;
  /** for checking against max file size */
  size?: number;
  url?: string;
  /** the subtitle shown in the uploading */
  subtitle?: string;
  file?: File;
  /** shown in the file after upload */
  content?: string;
}

export function fileToFileInfo(file: File, unique_key: string): FileInfo {
  return {
    name: file.name,
    key: unique_key,
    type: file.type,
    size: file.size,
    url: URL.createObjectURL(file),
    file,
  };
}

export function readFileAsURL(file: File): Promise<string> {
  return new Promise((resolve) => {
    const reader = new FileReader();

    reader.onload = function (ev: ProgressEvent<FileReader>) {
      const target = ev.currentTarget as FileReader;
      resolve(target.result as string);
    };

    reader.readAsDataURL(file);
  });
}
